// extracted by mini-css-extract-plugin
export default {"ecom-header":"DGneX0","ecomHeader":"DGneX0"};